import { makeStyles } from "@material-ui/core";

// @ts-ignore
const useStyles = makeStyles((theme: any) => {
  return {
    button: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: "pointer",
      padding: "0 16px",
      height: "40px",
      background: theme.custom.colors.primary,
      borderRadius: "4px",
      border: "none",
      outline: "none",
      color: theme.custom.colors.white,
      fontWeight: '700',
      textTransform: 'capitalize',
      justifyContent: 'center',
      fontSize: 16,
      fontFamily: 'Montserrat',
      lineHeight: '40px',
      '&.btn-primary': {
        borderRadius: 30,
        background: theme.custom.colors.purp,
      },
      '&.btn-secondary': {
        border: `1px solid ${theme.custom.colors.midBlack}`,
        background: '#fff',
        lineHeight: '30px',
        borderRadius: 30,
        color: theme.custom.colors.midBlack,
      },
      '&.btn-height-32': {
        height: 32,
        lineHeight: '32px',
      },
      '&.size-14': {
        fontSize: 14,
      },
      '&__loading': {
        marginLeft: '10px',
        '& svg': {
          color: '#fff'
        }
      },
      '&:disabled': {
        cursor: 'not-allowed',
        backgroundColor: 'gray',
        '&:hover': {
          backgroundColor: 'gray',
        }
      }
    }
  };
});

export default useStyles;
